import { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogActions, List, ListItem, TextField, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import { useDispatch, useSelector } from 'store';
import { getProject } from 'store/slices/project';

import deleteWarningIcon from 'assets/images/delete-warning.png';

const DeleteProjectPopup = ({ id, open, handleClosePopup, handleDeleteProject }) => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const { project } = useSelector((state) => state.project);
    const [details, setDetails] = useState(null);
    
    const [confirmString, setconfirmString] = useState(null);
    const [clicked, setClicked] = useState(false);
    
    const handleClose = () => {
        if (!clicked) {
            handleClosePopup();
        }
    };

    useEffect(() => {
        if(id != null) {
            dispatch(getProject(id))
        }
    }, [id]);

    useEffect(() => {
        setDetails(project);
    }, [project]);

    useEffect(() => {
        setconfirmString(null);
        setClicked(false);
    }, [open]);

    const handleConfirmDelete = () => {
        const newDetails = {
            ...details,
            status: -1
        };
        handleDeleteProject(newDetails)
    }
    
    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={open}
        >
            <DialogContent sx={{ position: 'relative' }}>
                <Close
                    sx={{
                        position: 'absolute',
                        right: 24,
                        top: 20,
                        width: 32,
                        height: 32,
                        color: clicked ? '#61616166' : '#616161',
                        cursor: clicked ? 'not-allowed' : 'pointer'
                    }}
                    onClick={handleClose}
                />
                <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '24px' }}>
                    <Box component="img" src={deleteWarningIcon} alt="Delete warning" />
                </Box>
                <Box sx={{ padding: '32px', marginBottom: '24px' }}>
                    <Typography sx={{ fontSize: '24px', fontWeight: 700, fontFamily: 'Gilroy-Bold', color: '#5A1C70', marginBottom: '16px' }}>
                        <FormattedMessage id="delete-project-warning-string-delete-project" />
                    </Typography>
                    <List sx={{ listStyleType: 'disc',paddingLeft: '24px', fontSize: '16px', fontWeight: 400, color: '#2D2D2D', ListItemneHeight: '25.6px' }}>
                        <ListItem sx={{ display: 'list-item', padding: '8px' }}>
                            <FormattedMessage id="delete-project-warning-string-point-one" />
                        </ListItem>
                        <ListItem sx={{ display: 'list-item', padding: '8px' }}>
                            <FormattedMessage id="delete-project-warning-string-point-two" />
                        </ListItem>
                    </List>
                </Box>
                <Box sx={{ padding: '32px' }}>
                    <Typography variant="h1" gutterBottom sx={{ fontSize: '0.875rem', fontWeight: 600, color: '#EE404C', marginBottom: '8px' }}>
                        <FormattedMessage id="delete-project-warning-string-type-delete" />
                    </Typography>
                    <TextField
                        fullWidth
                        id="userConfirmDelete"
                        name="userConfirmDelete"
                        disabled={clicked}
                        placeholder={intl.formatMessage({ id: 'delete-project-placeholder-confirm-delete' })}
                        onChange={(e) => {
                            setconfirmString(e.target.value)
                        }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                background: '#FFFFFF',
                                fieldset: {
                                    borderColor: '#C1C9D2'
                                },
                                input: {
                                    bgcolor: '#FFFFFF'
                                },
                                '&:hover fieldset': {
                                    borderColor: '#7A2897'
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#7A2897'
                                }
                            }
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    variant="contained"
                    size="large"
                    disabled={confirmString !== 'Delete' || clicked}
                    sx={{
                        backgroundColor: '#EE404C',
                        color: '#FFFFFF',
                        fontWeight: 700,
                        borderRadius: '16px',
                        '&:hover': {
                            backgroundColor: '#EE404C',
                            color: '#FFFFFF'
                        }
                    }}
                    onClick={() => {
                        setClicked(true);
                        handleConfirmDelete();
                    }}
                >
                    {clicked ? <CircularProgress size={26.25} sx={{ color: '#7A2897' }} /> : <FormattedMessage id="delete-project-button-delete-project" />}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteProjectPopup;
